import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#008d8a",
    },
    secondary: {
      main: "#007DAB",
      //
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          height: 50,
        },
      },
    },
  },
  typography: {
    fontSize: 12,
  },
});

export default theme;
